import React, { useState } from "react";
import EditBannerModal from "./EditBannerModal";
import AdminGalleryManager from "./AdminGalleryManager";
import { FaPhotoVideo, FaImages } from "react-icons/fa";

const ContentTabs = ({ bannerVideos, setBannerVideos, bannerText, setBannerText }) => {
  const [tab, setTab] = useState("banner");
  const [isBannerModalOpen, setBannerModalOpen] = useState(false);

  return (
    <div>
      {/* Tabs arriba */}
      <div className="flex justify-center gap-4 border-b border-blue-100 mb-6 pt-6">
        <button
          onClick={() => setTab("banner")}
          className={`flex items-center gap-2 px-6 py-3 rounded-t-xl font-bold text-lg ${
            tab === "banner"
              ? "bg-blue-600 text-white shadow"
              : "bg-blue-50 text-blue-600 hover:bg-blue-100"
          }`}
        >
          <FaPhotoVideo /> Banner Principal
        </button>
        <button
          onClick={() => setTab("galeria")}
          className={`flex items-center gap-2 px-6 py-3 rounded-t-xl font-bold text-lg ${
            tab === "galeria"
              ? "bg-blue-600 text-white shadow"
              : "bg-blue-50 text-blue-600 hover:bg-blue-100"
          }`}
        >
          <FaImages /> Galería
        </button>
      </div>

      {/* Contenido dinámico */}
      <div className="p-8">
        {tab === "banner" && (
          <div className="flex flex-col items-center gap-6">
            <button
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-xl font-bold shadow transition-all"
              onClick={() => setBannerModalOpen(true)}
            >
              Editar Banner
            </button>
            {/* Previsualización */}
            <div className="w-full flex items-center gap-4">
              <video src={bannerVideos[0]} className="w-28 h-16 rounded shadow border" muted />
              <div>
                <div className="font-bold text-blue-800">{bannerText.title}</div>
                <div className="text-xs text-blue-700">{bannerText.description}</div>
                <div className="text-xs mt-1">
                  <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded">{bannerText.buttonText}</span>
                </div>
              </div>
            </div>
            {isBannerModalOpen && (
              <EditBannerModal
                videos={bannerVideos}
                onSaveVideos={setBannerVideos}
                text={bannerText}
                onSaveText={setBannerText}
                onClose={() => setBannerModalOpen(false)}
              />
            )}
          </div>
        )}
        {tab === "galeria" && (
          <div>
            <AdminGalleryManager />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentTabs;
